import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import DownloadIcon from '@mui/icons-material/Download';

export interface IProps {
  /**
   * ボタンが押された場合に呼び出されます
   */
  onClick?: () => void;
}

export default function ModelDownloadButton(props: IProps) {
  const [open, setOpen] = useState(false);
  function handleMouseOver() {
    if (open === false) {
      setOpen(true);
    }
  }
  function handleMouseLeave() {
    if (open === true) {
      setOpen(false);
    }
  }
  return (
    <Tooltip title="download" arrow placement="bottom" open={open}>
      <IconButton
        aria-label="download"
        onClick={props.onClick}
        onMouseOver={handleMouseOver}
        onMouseLeave={handleMouseLeave}
      >
        <DownloadIcon />
      </IconButton>
    </Tooltip>
  );
}
